export const TEMPLATE_CODE_CREATED_SUCCESSFULLY = 'Template code created successfully.'
export const TEMPLATE_CODE_CREATTION_FAILED = 'Something went wrong, Template code not created.'
